import { useContext } from 'react';
import Context from './Context';

export default function useProjectApi() {
  const { project } = useContext(Context);
  return project;
}
